<template>
  <div>
    <modal class="modal--welcomeback modal--zero-balance" :modal-key="'invite_friend_modal'" @close="$emit('close')" :body-style="'invitation'">
      <template slot="header">
        <h1>{{ getTranslations.home_modals_invite_friend_title }}</h1>
        <img class="pinicon" src="static/images/invite_icon.svg" alt="">
      </template>
      <template slot="body">
        <p>{{ getTranslations.home_modals_invite_friend_description1 }} {{ numberFormatting(inviteConfig.invitePoints) }} {{ getTranslations.home_modals_invite_friend_description2 }}</p>
        <h2 class="modal_sub">{{ getTranslations.home_modals_invite_friend_invite_via_sms }}</h2>
        <form-field :placeholder-text="getTranslations.home_modals_invite_friend_mobile_placeholder"
                    :submit-text="getTranslations.home_modals_invite_friend_submit"
                    :extra-class="'phone_input'"
                    :has-errors="phone.hasErrors"
                    :has-success="phone.hasSuccess"
                    :error-text="getTranslations.visitor_sign_up_invalid_msisdn_msg"
                    :success-text="getTranslations.home_modals_invite_friend_success"
                    :action-on-click="smsInvite"/>
        <h2 class="modal_sub">{{ getTranslations.home_modals_invite_friend_invite_via_email }}</h2>
        <form-field :placeholder-text="getTranslations.home_modals_invite_friend_email_placeholder"
                    :submit-text="getTranslations.home_modals_invite_friend_submit"
                    :has-errors="mail.hasErrors"
                    :has-success="mail.hasSuccess"
                    :error-text="getTranslations.home_modals_invite_friend_email_error"
                    :success-text="getTranslations.home_modals_invite_friend_success"
                    :action-on-click="emailInvite"/>
        <div class="invite_fb" v-if="facebookFunctionality && !hideFacebookPointFields">
          <p>{{ getTranslations.home_modals_invite_friend_invite }}</p>
          <a href="#" @click.prevent="shareFriendsInvitation()">
            <div class="facebook_share_avatar">
              <div class="facebook_share_icon">
                <img src="static/images/fb_icon.svg">
              </div>
              <div class="facebook_share_text">
                <p>{{ getTranslations.home_store_share }}</p>
              </div>
            </div>
          </a>
        </div>
        <span class="fb_error_msg" v-if="fb_error">{{ getTranslations.home_store_this_fb }}</span>
      </template>
    </modal>
    <fade-transition>
      <invite-friend-personalize :info="createInfo()"
                                 v-if="showNextStep"
                                 @error="onError"
                                 @close="onSent"/>
    </fade-transition>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import Modal from '@/components/home/modals/shared/GenericModal';
import NumbersFormattingMixin from '@/common/mixins/numbersFormatting';
import FacebookMixin from '@/common/mixins/facebookIntegration';
import ValidationMixin from '@/common/mixins/validations';
import InviteFriendPersonalize from '@/components/home/modals/users/InviteFriendPersonalize';
import FadeTransition from '@/components/home/modals/shared/FadeTransition';
import FormField from '../../shared/FormField';

export default {
  name: 'invite-friend',
  mixins: [NumbersFormattingMixin, FacebookMixin, ValidationMixin],
  components: {
    InviteFriendPersonalize,
    FormField,
    Modal,
    FadeTransition,
  },
  data() {
    return {
      selectedType: '',
      selectedInput: '',
      types: {
        SMS: 'SMS',
        MAIL: 'EMAIL',
      },
      mail: {
        hasErrors: false,
        hasSuccess: false,
      },
      phone: {
        hasErrors: false,
        hasSuccess: false,
      },
      fb_error: false,
      redirectUrl: '',
      showNextStep: false,
    };
  },
  created() {
    this.redirectUrl = `${window.location.origin}/home/store/${this.getLocale || localStorage.getItem('locale')}/`;
    if (this.facebookFunctionality) {
      this.forceFbToScrapNewMetadata(this.redirectUrl, () => {
        // eslint-disable-next-line
        console.log('successful scrapping!');
      });
    }
  },
  methods: {
    createInfo() {
      return {
        type: this.selectedType,
        input: this.selectedInput,
      };
    },
    goToNextStep() {
      this.showNextStep = true;
    },
    onSent() {
      if (this.selectedType === this.types.SMS) {
        this.phone.hasSuccess = true;
      } else {
        this.mail.hasSuccess = true;
      }
      this.showNextStep = false;
    },
    onError() {
      if (this.selectedType === this.types.SMS) {
        this.phone.hasErrors = true;
      } else {
        this.mail.hasErrors = true;
      }
      this.showNextStep = false;
    },
    emailInvite(input) {
      this.email = input;
      this.validateEmail();
      this.mail.hasErrors = this.hasErrors;
      if (!this.mail.hasErrors) {
        this.selectedType = this.types.MAIL;
        this.selectedInput = input;
        this.goToNextStep();
      }
    },
    smsInvite(input) {
      this.msisdn = input;
      this.validateMsisdn();
      this.phone.hasErrors = this.hasErrors;
      if (!this.phone.hasErrors) {
        this.selectedType = this.types.SMS;
        this.selectedInput = input;
        this.goToNextStep();
      }
    },
    showError() {
      this.fb_error = true;
    },
    shareFriendsInvitation() {
      this.fb_error = false;
      this.share(
        this.userDetails.facebookId,
        this.userDetails.id,
        () => {
          // eslint-disable-next-line
          console.log('successful share invitation!');
        },
        this.showError,
      );
    },
  },
  computed: {
    ...mapState('common', [
      'hideFacebookPointFields',
      'facebookFunctionality',
      'userDetails',
      'inviteConfig',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/modals/users/InviteFriend.vue